"use client";

import React from "react";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";

export type MessageType = "INFO" | "SUCCESS" | "WARNING" | "ERROR";
export type MessagePayload = { text: string; type?: MessageType };

export const MESSAGE_TOAST_DURATION_MS = 5000;

export const addMessage = ({ text, type = "INFO" }: MessagePayload) => {
  const options = { duration: MESSAGE_TOAST_DURATION_MS };

  switch (type) {
    case "SUCCESS":
      toast.success(text, options);
      return;
    case "ERROR":
      toast.error(text, options);
      return;
    case "WARNING":
      toast.warning(text, options);
      return;
    case "INFO":
      toast.info(text, options);
      return;
  }
};

export const messagesToasterProps = {
  closeButton: false,
  duration: MESSAGE_TOAST_DURATION_MS,
  expand: true,
  mobileOffset: { bottom: "6rem" },
  offset: { bottom: "2rem" },
  position: "bottom-center",
  richColors: true,
  visibleToasts: 6,
} as const;

export const MessagesComponent = () => {
  return (
    <Toaster
      closeButton={messagesToasterProps.closeButton}
      duration={messagesToasterProps.duration}
      expand={messagesToasterProps.expand}
      mobileOffset={messagesToasterProps.mobileOffset}
      offset={messagesToasterProps.offset}
      position={messagesToasterProps.position}
      richColors={messagesToasterProps.richColors}
      visibleToasts={messagesToasterProps.visibleToasts}
    />
  );
};
